import { YesNo } from '@ace-clublabs/payments-component-library';
import { AppHeaderBackButton, Box } from '@ace-clublabs/shared-component-library';
import React from 'react';

interface Props {
  lastName: string;
  handleNext: (form: { yesNoValue: string }) => void;
  handleBack: () => void;
  isMobileApp: boolean;
}

const VerifyPolicyInfoForm: React.FC<Props> = ({ lastName, handleBack, handleNext, isMobileApp }) => {
  return (
    <div id="verify-policy-info-form">
      {!isMobileApp && <AppHeaderBackButton id="back-button" onClick={() => handleBack()} />}
      <Box className="margin16Bottom margin16Top">
        <YesNo
          title={`Are the first 3 letters of the Policy holder's last name ${lastName}?`}
          handleNext={handleNext}
          qmMask={true}
        ></YesNo>
      </Box>
    </div>
  );
};

export default VerifyPolicyInfoForm;
